var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSample(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8107 19.8107C16.8107 19.8107 16.3713 20.25 15.75 20.25H2.25C2.25 20.25 1.62868 20.25 1.18934 19.8107C1.18934 19.8107 0.75 19.3713 0.75 18.75V2.25C0.75 2.25 0.75 1.62868 1.18934 1.18934C1.18934 1.18934 1.62868 0.75 2.25 0.75H11.25C11.4489 0.75 11.6397 0.829018 11.7803 0.96967L17.0303 6.21967C17.171 6.36032 17.25 6.55109 17.25 6.75V18.75C17.25 18.75 17.25 19.3713 16.8107 19.8107ZM15.75 18.75V7.06066L10.9393 2.25H2.25V18.75H15.75Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5H16.5C16.9142 7.5 17.25 7.16421 17.25 6.75C17.25 6.33579 16.9142 6 16.5 6H12V1.5C12 1.08579 11.6642 0.75 11.25 0.75C10.8358 0.75 10.5 1.08579 10.5 1.5V6.75C10.5 7.16421 10.8358 7.5 11.25 7.5Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H12C12.4142 12 12.75 11.6642 12.75 11.25C12.75 10.8358 12.4142 10.5 12 10.5H6C5.58579 10.5 5.25 10.8358 5.25 11.25C5.25 11.6642 5.58579 12 6 12Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H12C12.4142 15 12.75 14.6642 12.75 14.25C12.75 13.8358 12.4142 13.5 12 13.5H6C5.58579 13.5 5.25 13.8358 5.25 14.25C5.25 14.6642 5.58579 15 6 15Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/Sample.cc853536234a7ebc4db91d2bddf57f82.svg";
export { ForwardRef as ReactComponent };